import { z } from "zod/v4-mini";

import { cz } from "@/utils/zodUtils";

import { TandemEventDefinition } from "../TandemTypes";

export type TempBasalRateCompletedPayload = {
  temp_rate_id?: number;
  time_left?: number;
};

export type TempBasalRateCompletedEvent = {
  tempRateId?: number;
  timeLeft?: number;
};

const tempBasalRateCompletedSchema = z.object({
  temp_rate_id: cz.permissive(z.number()),
  time_left: cz.permissive(z.number()),
});

export const LID_TEMP_RATE_COMPLETED = {
  value: 0x0f,
  name: "Temporary Basal Rate Completed Event",
  format: "..hi........",
  fields: ["temp_rate_id", "time_left"],
  postprocess: rec => ({
    tempRateId: rec.temp_rate_id,
    timeLeft: rec.time_left,
  }),
  schema: tempBasalRateCompletedSchema,
} as const satisfies TandemEventDefinition<TempBasalRateCompletedPayload, TempBasalRateCompletedEvent>;
